import {EventEmitter, Injectable} from '@angular/core';

@Injectable()
export class EditToggleService {

  private _isOn = false;
  public toggleEmitter = new EventEmitter<boolean>();
  constructor() {
  }

  async setState(isOn: boolean) {
    this._isOn = isOn;
    this.toggleEmitter.emit(this._isOn);
  }

  getState(): boolean {
    return this._isOn;
  }
}
